module.exports = __webpack_public_path__ + "img/Pista_01_I.9d3579bd.png";